(ns teamoesterreich.admin-mode.data.user
  (:require [clojure.walk]
            [clojure.walk]
            [goog.json :as json]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.util.download :as h-download]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]))




(defn get-user-map-elements [parms done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-map-elements")
                   (json/serialize (clj->js parms))
                   (fn [r-list status]
                     ;;(log/debug "user-map-elements done" r-list status)
                     (when (= status 200)
                       (done-fn
                         (into {} (js->clj (json/parse r-list)))
                         )))))

(defn get-user-list-elements [parms done-fn & [all]]
  ;(log/debug "user-list-elements " (json/serialize (clj->js parms)))
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-list-elements-detail" (when all "?all=1"))
                   (json/serialize (clj->js parms))
                   (fn [r-list status]
                     ;(log/debug "user-list-elements done" r-list status)
                     (when (= status 200)
                       (done-fn
                         (into {} (js->clj (json/parse r-list)))
                         )))))
(defn get-user-list-elements-detail [parms done-fn & [all]]
  (log/debug "user-list-elements-detail " (json/serialize (clj->js parms)))
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-list-elements-detail" (when all "?all=1"))
                   (json/serialize (clj->js parms))
                   (fn [r-list status]
                     ;(log/debug "user-list-elements done" r-list status)
                     (when (= status 200)
                       (done-fn
                         (into {} (js->clj (json/parse r-list)))
                         )))))
(defn csv-user-list-elements-detail [parms]
  (log/debug "user-list-elements-detail " (json/serialize (clj->js parms)))
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/download/user-list")
                   (json/serialize (clj->js parms))
                   (fn [response status]
                     (log/debug "csv-download got" response status)
                     (when (= status 200)
                       (js/window.open (aget (json/parse response) "url") "_blank")))))



(defn get-user-details [tomId done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user-details?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug "user-list-get-user-details done" r-list status)
                    (if (= status 200)
                      (done-fn
                        (merge {:reqTomId tomId} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                        )
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht geladen werden! " status :reqTomId tomId)}
                               )))))


(defn get-user-list-lebensretter [parms done-fn]
  (log/debug "user-list-lebensretter " (json/serialize (clj->js parms)))
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-list-lebensretter")
                   (json/serialize (clj->js parms))
                   (fn [r-list status]
                     (when (= status 200)
                       (done-fn
                         (into {} (js->clj (json/parse r-list)))
                         )))))

(defn get-user-list-lebensretter-optIn [done-fn]
  (log/debug "user-list-lebensretter-optIn")
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/lr-opt-in")
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (js->clj (json/parse r-list))
                        )))))

(defn get-user-elem-lebensretter [tomId done-fn]
  (log/debug "user-elem-lebensretter " tomId)
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user-list-lebensretter/" tomId)
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (into {} (js->clj (json/parse r-list)))
                        )))))

(defn get-user-list-lebensretter-cnt [parms done-fn]
  (log/debug "user-list-lebensretter-cnt " (json/serialize (clj->js parms)))
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-list-lebensretter-cnt")
                   (json/serialize (clj->js parms))
                   (fn [r-list status]
                     (when (= status 200)
                       (done-fn
                         (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                         )))))


(defn get-user-all [tomId done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/toe/" tomId)
                  (fn [body status]
                    (log/debug "user-list-get-user-details done" status)
                    (if (= status 200)
                      (done-fn
                        (merge {:invalidated false
                                :reqTomId    tomId}
                               (clojure.walk/keywordize-keys (js->clj (json/parse body)))))
                      (done-fn {:error    (str "Fehler: Datensatz konnte nicht geladen werden! " status "\n" body)
                                :reqTomId tomId}
                               )))))
(defn get-user-me [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/me")
                  (fn [body status]
                    (log/debug "get-user-me done" status)
                    (if (= status 200)
                      (done-fn
                        (let [me-data (clojure.walk/keywordize-keys (js->clj (json/parse body)))]
                          (merge {:invalidated false
                                  :reqTomId    (:user-tomId me-data)}
                                 me-data)))
                      (done-fn {:error        (str "Fehler: Datensatz konnte nicht geladen werden! " status "\n" body)
                                :error-status status
                                :reqTomId     nil}
                               )))))

(defn get-user-uuid-all [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/" uuid)
                  (fn [r-list status]
                    (log/debug "user-list-get-user-details done" r-list status)
                    (if (= status 200)
                      (done-fn
                        (merge {:invalidated false
                                :uuid        uuid} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                        )
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht geladen werden! " status :uuid uuid)}
                               )))))

(defn actual-user-valid? [tomId !actual-user]
  (and (= tomId (:reqTomId @!actual-user)) (not (:invalidated @!actual-user))))

(defn actual-user-invalidate [!actual-user]
  (swap! !actual-user assoc :invalidated true))


(defn >user-edit-field [user-uuid obj cb-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/user/" user-uuid)
                    (ajax/serialize (merge {:user-uuid user-uuid}
                                           obj))
                    cb-fn))
(defn >reset-location [user-tomId cb-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/toe/" user-tomId "/reset-lat-lng") cb-fn))
(defn >reset-orgId [user-tomId cb-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/toe/" user-tomId "/reset-orgId") cb-fn))

(defn user-update [& [on-finished]]
  (let [tomId (get-in @vstate/app-state [:selected-user :user-tomId])]
    (log/debug "user-update do " tomId)
    (when tomId
      (get-user-all tomId (fn [response]
                            (swap! vstate/app-state assoc :selected-user response)
                            (when on-finished (on-finished))
                            )))))

(defn >user-unsubscribe [tomId & [cb-fn]]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/toe/" tomId "/unsubscribe") cb-fn))

(defn >user-cancel-unsubscribe [tomId & [cb-fn]]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/toe/" tomId "/cancel-unsubscribe") cb-fn))

(defn >user-delete [user-uuid & [cb-fn]]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/user/" user-uuid) cb-fn))

(defn user-update-by-uuid [uuid & [on-finished]]
  (let [tomId (get-in @vstate/app-state [:selected-user :user-tomId])
        user-uuid (get-in @vstate/app-state [:selected-user :user-uuid])]
    (log/debug "user-update do" uuid "=" user-uuid " - " tomId)
    (when (= user-uuid uuid)
      (get-user-all tomId (fn [response]
                            (swap! vstate/app-state assoc :selected-user response)
                            (when on-finished (on-finished))
                            )))))


(defn get-csv [selection-uuid]
  (h-download/open-download-url (backend/get-auth) (str "/download/user-selection/" selection-uuid)))


(defn email-to-tomIds [tomIds subject message from done-fn & [self]]
  (log/debug "email-to-list " (clj->js tomIds) (clj->js message) subject)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-message/send-email-to-tomIds")
                   (ajax/serialize {:subject subject
                                    :message message
                                    :tomIds  tomIds
                                    :from    from
                                    :to-me   self})
                   (fn [r-list status]
                     (log/debug "email-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))

(defn sms-to-tomIds [tomIds message done-fn]
  (log/debug "sms-to-list " tomIds message)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-message/send-sms-to-tomIds")
                   (ajax/serialize {:message message
                                    :tomIds  tomIds})
                   (fn [r-list status]
                     (log/debug "sms-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))
(defn push-to-tomIds [tomIds message done-fn]
  (log/debug "sms-to-list " tomIds message)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-message/send-push-to-tomIds")
                   (ajax/serialize {:message message
                                    :tomIds  tomIds})
                   (fn [r-list status]
                     (log/debug "sms-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))



(defn >extend-clearance [clearance-uuid obj cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid "/extend")
                   (ajax/serialize obj)
                   cb-fn))





(defn >user-edit-document-field [document-uuid obj cb-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/user/document/" document-uuid)
                    (ajax/serialize (merge {:userDocument-uuid document-uuid}
                                           obj))
                    cb-fn))

(defn >userDocument-upload [user-uuid userDocument-type {:keys [file-name buffer content-type on-finished]}]
  (let [url (str backend/BASE_URL "/user/" user-uuid "/document?type=" userDocument-type)]
    (log/out "UPLOAD" url "--" file-name "--" content-type "--" on-finished)
    (ajax/auth-post-file> (backend/get-auth) url buffer file-name content-type on-finished)))




(defn get-active-clearance [d-user]
  (:user-lrClearance d-user))

(defn is-pushable [d-user]
  (reduce (fn [c e]
            ;(js/console.log "is-pushable ? " c "  dev:" (clj->js (:device-pushToken e)))
            (or c (> (and (:device-pushToken e) (> (count (:device-pushToken e)) 1)))))
          false
          (:user-devices d-user)))


(defn >user-fb-sync-request [tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user/toe/" tomId "/fb-sync")))


(defn >search-user [srch on-finished]
  (let [url (str backend/BASE_URL "/user/search-toe?max=100&")]
    (ajax/auth-post> (backend/get-auth) url srch (fn [res _] (on-finished (clojure.walk/keywordize-keys (js->clj (json/parse res))))))))

